module.exports = "mutation BulkDeleteOrders($orders: [ID!]!) {\n  bulkDeleteOrders(orders: $orders) {\n    successful\n    failedCount\n  }\n}\n"